<mat-toolbar role="heading" color="primary" class="header">
  <div class="seccion">
    <button mat-icon-button (click)="clickBotonSidenav.emit()">
      <mat-icon>menu</mat-icon>
    </button>
    <a class="logo" routerLink="/">
      <img src="assets/logo/atlas-light.png" />
      <img class="organizacion" *ngIf="logoOrg" [src]="logoOrg" />
    </a>
  </div>
  <div class="seccion">
    <!-- Notificaciones -->
    <ng-container
      *ngIf="notificacionesService.notificaciones$ | async as notificaciones"
    >
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon
          [matBadge]="notificacionesService.noLeidas$ | async"
          [matBadgeHidden]="(notificacionesService.noLeidas$ | async) == 0"
          matBadgeColor="warn"
          aria-hidden="false"
        >
          notifications
        </mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="notificaciones">
        <h3 class="titulo">
          <mat-icon inline>notifications</mat-icon> Notificaciones
        </h3>
        <mat-divider></mat-divider>
        <button mat-menu-item *ngIf="notificaciones.length === 0">
          <span>No hay notificaciones</span>
        </button>
        <div class="notificaciones-cont">
          <ng-container
            *ngFor="let notificacion of notificaciones; let i = index"
          >
            <button mat-menu-item (click)="clickNotificacion(notificacion)">
              <div class="notificacion">
                <div
                  class="circulo"
                  [class.fondo-warn]="!notificacion.leida"
                ></div>
                <span>{{ notificacion.mensaje }}</span>
                <span class="fecha mat-small">
                  {{ notificacion.fechaCreacion }}
                </span>
              </div>
            </button>
            <mat-divider *ngIf="i + 1 != notificaciones.length"></mat-divider>
          </ng-container>
          <button
            mat-menu-item
            (click)="
              $event.stopPropagation();
              notificacionesService.cargarMasNotificaciones$()
            "
            class="cargar-mas"
          >
            Cargar más...
          </button>
        </div>
      </mat-menu>
    </ng-container>

    <!-- Perfil -->
    <ng-container *ngIf="usuario">
      <button mat-icon-button [matMenuTriggerFor]="perfil">
        <mat-icon>person</mat-icon>
      </button>
      <mat-menu #perfil="matMenu" class="perfil">
        <h3 class="titulo"><mat-icon inline>person</mat-icon> Usuario</h3>
        <mat-divider></mat-divider>
        <p><b>Username:</b> {{ usuario.username }}</p>
        <p><b>Correo:</b> {{ usuario.email }}</p>
        <p><b>Rol:</b> {{ usuario.rol | titlecase }}</p>
      </mat-menu>
    </ng-container>

    <!-- Logout -->
    <button mat-button (click)="autenticacionService.logout$()">
      <mat-icon>logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
